import VueRouter from 'vue-router';
import { isSubdivisionRequired } from '../../../util';
import { magic } from '@gig/magic-sdk';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import { modalService } from '@gig/magic-common';
import { RouteName } from '../../../routes/routes.constants';
/**
 * Guard to check if subdivision is required and prevent user from proceeding if not filled
 * @param router
 */
const NO_SUBDIVISION_DEFINED = '00000000-0000-0000-0000-000000000000';

export function initSubdivisionGuard(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
        if (
            !magic.session.getUser() ||
            to.name === RouteName.LOGOUT ||
            !(await isSubdivisionRequired())
        ) {
            return next();
        }

        if (isSubdivisionModalOpen()) {
            if (to.name !== RouteName.HOME) {
                return next(
                    new Error(
                        'Navigation canceled due to user block (subdivision information)',
                    ),
                );
            } else {
                return next();
            }
        }

        const profileV2Promise: ReturnType<
            typeof magic.methods.users.getProfileV2
        > = magic.invokeCached(60, magic.methods.users, 'getProfileV2')();

        const user = await profileV2Promise;

        if (
            user &&
            user.country === Country.CANADA &&
            user.subdivisionID === NO_SUBDIVISION_DEFINED
        ) {
            const subdivisionModal = document.createElement(
                'magic-subdivision-modal',
            );
            const subdivisionModalHeader = 'subdivision-modal.title';
            const optionsSubdivisionModal = {
                dismissible: false,
                dismissibleBackdrop: false,
                displayOnTop: true,
                keepAfterClear: true,
                onClose: () => {
                    // the user has submitted the subdivision
                    // so the next call to `getProfileV2` should fetch the new information
                    magic.deleteCached(magic.methods.users, 'getProfileV2')();
                },
            };
            modalService.open(
                subdivisionModalHeader,
                subdivisionModal,
                optionsSubdivisionModal,
            );
            return next({ name: RouteName.HOME });
        }

        next();
    });
}

function isSubdivisionModalOpen() {
    return document.getElementsByTagName('magic-subdivision-modal').length != 0;
}
